import script from "./rename-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./rename-dialog.vue?vue&type=script&setup=true&lang=js"

import "./rename-dialog.vue?vue&type=style&index=0&id=2585b5e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2585b5e6"]])

export default __exports__